<template>
    <VJoyLink :class="['mui-c-link', {'mui-c-link--icon': icon}]" :href="props.href" :target="props.target" :icon="icon">
        {{ props.text }}
    </VJoyLink>
</template>
<script setup lang="ts">
    import {VJoyLink} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    const props = defineProps<{
        href: string;
        text: string;
        target?: string;
        icon?: JoyIconsId;
    }>();
</script>

<style lang="scss">
    a.mui-c-link.joy-link {
        --link-default-color: var(--joy-color-neutral-70);
        --link-default-color-hover: var(--joy-color-neutral-50);
        --link-default-color-visited: var(--joy-color-neutral-50);

        &,
        &:visited,
        & > span.joy-link__text,
        &:visited > span.joy-link__text {
            text-decoration-color: var(--link-default-color);
            color: var(--link-default-color);
        }

        &,
        &:visited {
            width: auto;
            text-decoration: underline;
            text-underline-offset: 6px;
            text-decoration-thickness: 2px;
        }

        &:hover,
        &:hover > span.joy-link__text {
            text-decoration-color: var(--link-default-color-hover);
            color: var(--link-default-color-hover);
        }

        &.mui-c-link--icon {
            text-decoration: none;

            & > span.joy-icon {
                font-size: 10px;
            }

            & > span.joy-link__text {
                position: relative;
                top: -1px;
            }
        }
    }
</style>
